<main class="contacts-list">
  <action-title-header
    [title]="'Contacts.List.title' | translate"
    [buttonText]="'Contacts.List.addContact' | translate"
    (onAction)="addContact()"
    [sticky]="true"
  >
    <list-search />
    <list-filters-btn-v2 [filters]="ContactsFiltersComponent" />
    <ng-template #action>
      <div class="d-flex gap-4">
        <app-button
          *ngIf="listService.config?.urlExport"
          [loading]="loading"
          (onClick)="downloadExcel()"
          [config]="{
            type: ButtonTypes.NEW_PRIMARY_BLUE,
            size: ButtonSize.LARGE,
            smSize: ButtonSize.SMALL,
            appendSrc: './assets/img/download-icon.svg'
          }"
        />

        <app-button
          [permission]="{ group: PermissionsGroups.CONTACTS, action: 'ADD' }"
          (onClick)="addContact()"
          [loading]="loading"
          [config]="{
            type: ButtonTypes.NEW_PRIMARY_BLUE,
            text: WindowHelper.isLessXXL ? '' : ('Contacts.List.addContact' | translate),
            size: ButtonSize.LARGE,
            smSize: ButtonSize.SMALL,
            prependSrc: './assets/img/ic-plus-add.svg'
          }"
        />
      </div>
    </ng-template>
  </action-title-header>

  <div class="container-fluid--30 contacts-list__content">
    <app-list
      *ngIf="inited"
      [filters]="ContactsFiltersComponent"
      [config]="config"
      [emptyTemplate]="emptyTemplate"
      [searchName]="'Contacts.List.searchContact' | translate"
      [selected]="selected"
      (activate)="activate($event)"
      [showToggleMenu]="showToggleMenu.bind(this)"
      [headerHidden]="true"
      #list
    />
  </div>
</main>

<ng-template #emptyTemplate>
  <div class="d-flex flex-column align-items-center mt-4 empty">
    <img
      draggable="false"
      src="/assets/img/Contact.svg"
      alt="{{ 'Contacts.List.addContact' | translate }}"
      class="mb-4 mt-4"
    />
    <div class="mt-2">{{ 'Contacts.List.emptyList' | translate }}</div>
    <app-button
      [permission]="{
        group: PermissionsGroups.CONTACTS,
        action: 'ADD'
      }"
      (onClick)="addContact()"
      [config]="{
        type: ButtonTypes.SECONDARY_BLUE,
        text: 'Contacts.List.addContact' | translate,
        size: ButtonSize.LARGE,
        prependSrc: './assets/img/ic-plus-add.svg'
      }"
    />
  </div>
</ng-template>

<contact-name-cell #contactNameCell />
<contact-type-cell #contactTypeCcell />
<contact-phone-cell #contactPhoneCell />
<contact-email-cell #contactEmailCell />
<contact-availability-cell #contactAvailabilityCell />
<contact-parents-count-cell #contactParentCountCell />
<contact-subcontacts-count-cell #contactSubcontactsCountCell />
<contact-creator-cell #contactCreatorCell />
<contact-function-cell #contactFunctionCell />
<contact-tags-cell #contactTagsCell />
